package org.example.project.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import battleships.shared.generated.resources.Res
import battleships.shared.generated.resources.ocean
import org.jetbrains.compose.resources.painterResource

@Composable
fun ResultScreen(
    playerName: String,
    score: Int,
    penalties: Int,
    correctAnswers: Int,
    won: Boolean,
    opponentName: String,
    onPlayAgain: () -> Unit,
    onHome: () -> Unit
) {

    Box(
        modifier = Modifier.fillMaxSize()
    ) {

        Image(
            painter = painterResource(Res.drawable.ocean),
            contentDescription = null,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )

        Box(
            Modifier
                .fillMaxSize()
                .background(Color.Black.copy(alpha = 0.45f))
        )

        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(32.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {

            Text(
                "BATTLE REPORT",
                color = Color.White,
                fontSize = 42.sp,
                fontWeight = FontWeight.ExtraBold,
                letterSpacing = 3.sp
            )

            Spacer(Modifier.height(20.dp))

            Surface(
                color =
                    if (won)
                        Color(0x3300AA44)
                    else
                        Color(0x44AA0000),

                border = BorderStroke(
                    2.dp,
                    if (won)
                        Color(0xFF00FF66)
                    else
                        Color(0xFFFF4444)
                ),

                shape = RoundedCornerShape(20.dp)
            ) {

                Text(
                    text =
                        if (won)
                            "VICTORY"
                        else
                            "DEFEAT",

                    modifier = Modifier.padding(
                        horizontal = 40.dp,
                        vertical = 18.dp
                    ),

                    color =
                        if (won)
                            Color(0xFF00FF66)
                        else
                            Color(0xFFFF5555),

                    fontSize = 38.sp,
                    fontWeight = FontWeight.Bold
                )
            }

            Spacer(Modifier.height(20.dp))

            Text(
                text =
                    if (won)
                        "Enemy fleet commanded by $opponentName has been destroyed."
                    else
                        "$opponentName has sunk your fleet.",

                color = Color.White.copy(alpha = 0.9f),
                textAlign = TextAlign.Center,
                fontSize = 18.sp
            )

            Spacer(Modifier.height(30.dp))

            Surface(
                modifier = Modifier.width(450.dp),

                color = Color(0xAA071420),

                border = BorderStroke(
                    2.dp,
                    Color(0xFF00CFFF)
                ),

                shape = RoundedCornerShape(18.dp)
            ) {

                Column(
                    modifier = Modifier.padding(24.dp)
                ) {

                    Text(
                        "MISSION SUMMARY",
                        color = Color(0xFF00CFFF),
                        fontWeight = FontWeight.Bold,
                        fontSize = 20.sp
                    )

                    Spacer(Modifier.height(18.dp))

                    StatLine("Commander", playerName, Color.White)
                    StatLine("Mission Score", score.toString(), Color(0xFF00CFFF))
                    StatLine("Intel Gathered", correctAnswers.toString(), Color(0xFF00FF66))
                    StatLine("Penalties", penalties.toString(), Color(0xFFFF5555))
                }
            }

            Spacer(Modifier.height(36.dp))

            Row(
                horizontalArrangement = Arrangement.spacedBy(20.dp)
            ) {

                Button(
                    onClick = onPlayAgain,

                    colors = ButtonDefaults.buttonColors(
                        containerColor = Color(0xFF00CFFF)
                    ),

                    shape = RoundedCornerShape(12.dp)
                ) {

                    Text(
                        "NEW MATCH",
                        color = Color.Black,
                        fontWeight = FontWeight.Bold
                    )
                }

                OutlinedButton(
                    onClick = onHome,

                    border = BorderStroke(
                        2.dp,
                        Color.White
                    ),

                    shape = RoundedCornerShape(12.dp)
                ) {

                    Text(
                        "RETURN HOME",
                        color = Color.White
                    )
                }
            }
        }
    }
}

@Composable
private fun StatLine(
    label: String,
    value: String,
    valueColor: Color
) {

    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {

        Text(
            label,
            color = Color.White.copy(alpha = 0.8f),
            fontSize = 16.sp
        )

        Text(
            value,
            color = valueColor,
            fontWeight = FontWeight.Bold,
            fontSize = 16.sp
        )
    }

    Spacer(Modifier.height(10.dp))
}